import SellerLayout from './components/SellerLayout';
import AddressesPage from './components/AddressesComponents/AddressesPage';

const Addresses = () => {
    return (
        <div className="request-page" style={styles.pageWrapper}>
            <SellerLayout>
                <div style={styles.innerWrapper}>
                    <div style={styles.addressesPageWrapper}>
                        <AddressesPage />
                    </div>
                </div>
            </SellerLayout>
        </div>
    );
};

export default Addresses;

const styles = {
    pageWrapper: {
        backgroundColor: '#FFF',
        minHeight: '100vh',
    },
    innerWrapper: {
        marginBottom: '30px',
        marginTop: '20px',
    },
    addressesPageWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginLeft: '20px',
        marginBottom: '10px',
    },
};
